import { useCallback, useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';

const DELAY = 3000;
const SCHEDULE_DEMO_FORM_URL =
  'https://share.hsforms.com/1XQ7-VhK4SZWHfrF2RZTBqgeigrh';

interface IScheduleDemoFormProps {
  automaticLaunch: boolean;
}

export const useScheduleDemoForm = ({
  automaticLaunch,
}: IScheduleDemoFormProps) => {
  const [hasLaunchedDemo, setHasLaunchedDemo] = useLocalStorage(
    'hasLaunchedDemo',
    false
  );

  const launchScheduleDemo = useCallback(() => {
    window.open(SCHEDULE_DEMO_FORM_URL, '_blank', 'noopener,noreferrer');
    setHasLaunchedDemo(true);
  }, [setHasLaunchedDemo]);

  useEffect(() => {
    if (!automaticLaunch || hasLaunchedDemo) {
      return;
    }

    setTimeout(() => {
      launchScheduleDemo();
    }, DELAY);
  }, [automaticLaunch, hasLaunchedDemo, launchScheduleDemo]);

  return {
    launchScheduleDemo,
  };
};
